import { SpinNGoSummary } from '@app/models/spin-n-go-summary';
import { createAction, props } from '@ngrx/store';

export const updateLoader = createAction('[Spin N Go Summaries] Update Loader', props<{ loader: boolean }>());
export const updateAll = createAction('[Spin N Go Summaries] Update Spin N Go Summaries', props<{ spinNGoSummaries: SpinNGoSummary[] }>());
export const updateOne = createAction('[Spin N Go Summaries] Update Spin N Go Summary', props<{ spinNGoSummary: SpinNGoSummary }>());
 